/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {

        // All pages

        'common': {

            init: function() {


               
                // JavaScript to be fired on all pages

                var slice = jQuery('.slice-parent');

               

                function myFunction() {

                    setTimeout(function(){
                         
                            jQuery('.slice-parent').css('position', 'relative');
                        
                    }, 3000);

                }

                if (slice) {
                
                    myFunction();

                }


                jQuery('.responsive-tabs').responsiveTabs({
                accordionOn: ['xs', 'sm'] // xs, sm, md, lg
                });
                                    

                 jQuery('#horizontalTab').easyResponsiveTabs({
	
                    type: 'default', //Types: default, vertical, accordion           
                    width: 'auto', //auto or any width like 600px
                    fit: true,   // 100% fit in a container
                    closed: 'accordion', // Start closed if in accordion view
                    activate: function(event) { // Callback function if tab is switched
                    var $tab = $(this);
                    var $info = $('#tabInfo');
                    var $name = $('span', $info);
                    $name.text($tab.text());
                    $info.show();
                    }

                });

                jQuery('#verticalTab').easyResponsiveTabs({
                type: 'vertical',
                width: 'auto',
                fit: true
              });


            //   jQuery('.slider').slick ({

            //         // infinite: true,
            //         slidesToShow: 1,
            //         slidesToScroll: 1,
            //         dots:true,
            //         autoplay: false,
            //         autoplaySpeed: 3000,
            //         vertical: true,
            //         verticalSwiping: true,

            //     });



            jQuery('.box span').on({
                mouseenter: function(){

                

                   jQuery(this).parent().addClass('myorgbox');

                
                
                },  
                mouseleave: function(){
                // jQuery(this).css("color", "#fff");
                jQuery(this).parent().removeClass('myorgbox', {duration:500});
                }, 
                
            });   



                 jQuery('.slider').slick({

                    // infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:true,
                    autoplay: false,
                    autoplaySpeed: 3000

                });

                jQuery('.testimonial-wrap').slick({

                    // infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:true,
                    autoplay: false,
                    autoplaySpeed: 3000

                });

                

                jQuery('.ncr-slider').slick({

                    // infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    dots:true,
                    autoplaySpeed: 3000

                });



                jQuery("#uploadBtn").change(function() {

                    var path = this.files[0];

                    jQuery("#uploadFile").val(path.name);

                });

                jQuery('.img-slider').slick({
                   
                    // infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:true,
                    arrows:false,
                    autoplay: true,
                    dots:true,
                    autoplaySpeed: 3000,

                         responsive: [
                    
                        {

                            breakpoint: 1024,
                    
                            settings: {

                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: true,

                            }

                        },

                        {

                            breakpoint: 600,

                            settings: {

                                slidesToShow: 1,
                                slidesToScroll: 1,
                                

                            }

                        },

                        {
                            breakpoint: 480,

                            settings: {
                                
                                slidesToShow: 1,
                                slidesToScroll: 1
                    
                            }

                        }
                
                    ]
                            
                });


                jQuery('.our-client').slick({

                    slidesToShow: 4,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    arrows: true,
                    nextArrow: '.slick-next',
                    prevArrow: '.slick-prev',

                    responsive: [

                        {

                            breakpoint: 1024,

                            settings: {

                                slidesToShow: 3,
                                slidesToScroll: 3,
                                infinite: true,

                            }

                        },

                        {

                            breakpoint: 600,

                            settings: {

                                slidesToShow: 2,
                                slidesToScroll: 2

                            }

                        },

                        {
                            breakpoint: 480,

                            settings: {

                                slidesToShow: 1,
                                slidesToScroll: 1

                            }

                        }

                    ]

                });

                jQuery('.testimonial').slick({

                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    arrows: false

                });

                    jQuery('.casesdy-slider').slick({

                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: true,
                        dots:true,
                        autoplaySpeed: 7000,
                        arrows:false

                    });


                // jQuery('.corptesslide').slick({

                //         infinite: true,
                //         slidesToShow: 1,
                //         slidesToScroll: 1,
                //         autoplay: true,
                //         dots:true,
                //         autoplaySpeed: 7000,
                //         arrows:false

                //     });
                   


                jQuery('.ncr-testimonials').slick({

                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    nextArrow: '.slick-next',
                    prevArrow: '.slick-prev'
                    

                });

                jQuery('.show-pop').bind('click', function(e) {

                    var id = jQuery(this).attr("href");
                    // Prevents the default action to be triggered.
                    e.preventDefault();

                    var apply = jQuery(this).parent().parent().parent().parent().parent().siblings("h3").text();
                
                    var query = 'span.Position input';
                    // debugger;

                    // Triggering bPopup when click event is fired
                    jQuery(id).bPopup({

                        position: ['auto', 'auto'],
                        onOpen: function() {

                            jQuery(query).val(apply);

                        } 

                    });

                    

                });

                jQuery(".resource-btn").click(function(e) {

                    e.preventDefault();

                    jQuery('#download-form .postid').val(jQuery(this).attr("data-id"));
                    jQuery('#download-form .postname').val(jQuery(this).attr("data-title"));
                    jQuery('#download-form .resourceurl').val(jQuery(this).attr("data-url"));

                    jQuery('.resource-form').bPopup({

                        position: ['auto', 'auto'],

                        onOpen: function() {

                            jQuery('#download-form').trigger("reset");

                            var validator = jQuery("#download-form").validate();
                            validator.resetForm();

                        },

                    });

                });

                jQuery("#download-form").validate({

                    rules: {

                        name: {
                            required: true,
                        },

                        emailid: {
                            required: true,
                            email: true,
                        },

                        company: {
                            required: true,
                        },

                        phoneno: {
                            required: true,
                            number: true
                        },

                    },

                    // Specify the validation error messages
                    messages: {

                        name: "Provide your full name",

                        emailid: "Provide a valid mail id",

                        company: "Provide the company name",

                        phoneno: "Provide the valid phone no",

                    },

                    submitHandler: function(form) {

                        jQuery.ajax({

                            type: "POST",
                            url: ajaxurl,
                            data: {
                                action: 'download_resources_ajax_response',
                                'name': jQuery("#download-form .name").val(),
                                'emailid': jQuery("#download-form .emailid").val(),
                                'company': jQuery("#download-form .company").val(),
                                'phoneno': jQuery("#download-form .phoneno").val(),
                                'postid': jQuery("#download-form .postid").val(),
                                'postname': jQuery("#download-form .postname").val(),
                                'resourceurl': jQuery("#download-form .resourceurl").val(),
                            },

                            success: function(data) {

                                var win = window.open(data, '_blank');

                                if (win) {

                                    var bPopup = jQuery('.resource-form').bPopup();
                                    bPopup.close();
                                    win.focus();

                                } else {

                                    alert('Please allow popups for this website');

                                }

                            }

                        });

                    }

                });

                var scroll = 0;

                // Header Scroll

                jQuery(window).scroll(function() {

                    var scrollPos = $(window).scrollTop();

                    if (scrollPos > 100) {

                        if (scroll === 0) {

                            jQuery('.home header').addClass('logo2');

                            scroll++;

                        }

                    }

                    if (scrollPos === 0) {

                        jQuery('.home header').removeClass('logo2');

                        scroll = 0;

                    }

                });

                // Responsive Menu

                jQuery('#menu-primary').slicknav({

                    label: '',
                    prependTo: 'header .nav-primary',
                    

                });

                jQuery('#mobile-menu-soln').slicknav({

                    label: 'View More',
                    prependTo: '.soln-menu',

                });

         

                // Stat Counter

                jQuery('.stat').counterUp({

                    delay: 10,
                    time: 1000
                });

                function getRandomSize(min, max) {
                    return Math.round(Math.random() * (max - min) + min);
                }

                jQuery(".btn-expand a").click(function(e) {

                    e.preventDefault();

                    jQuery(this).hide();

                    jQuery(".expand-content").fadeIn("600");

                });

            if (jQuery("#wpcf7-f4471-p4469-o1").length > 0 ) {

                    document.addEventListener( 'wpcf7mailsent', function( event ) {

                        location = 'http://nfs2.staging.wpengine.com/wp-content/uploads/2017/05/Corporate-PowerPoint.pdf';

                       // alert(window.location.hostname);
                    
                    }, false );

                }

                // Career Read More and Read Less

                jQuery('.toggle-content').hide();
                
                jQuery('.toggle-open').click(function(e) {

                e.preventDefault();

                if(jQuery(this).hasClass('open')){

                jQuery(this).parents('.panel-group').find('.toggle-content').slideUp();

                jQuery(this).parents('.expand').find('.toggle-content').slideUp();

                jQuery(this).removeClass('open').html('Read More');

                } else {
                
                jQuery(this).parents('.panel-group').find('.toggle-content').slideDown();

                jQuery(this).parents('.expand').find('.toggle-content').slideDown();

                jQuery(this).addClass('open').html('Read Less');

                }
                return false;
                
                });

            },

            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }

        },

        // Home page

        'home': {

            init: function() {

                // JavaScript to be fired on the home page

               
            },

            finalize: function() {

                // JavaScript to be fired on the home page, after the init JS

            }

        },

        // About us page, note the change from about-us to about_us.

        'about_us': {

            init: function() {

                // JavaScript to be fired on the about us page

            }

        }

    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event

    var UTIL = {

        fire: function(func, funcname, args) {

            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {

                namespace[func][funcname](args);

            }

        },

        loadEvents: function() {

            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {

                UTIL.fire(classnm);

                UTIL.fire(classnm, 'finalize');

            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }

    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.